import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent, ref, computed } from "vue";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { BookingStatus, PSSType } from "@/types/db/product-slot-state";
import BookingModule from "@/store/modules/booking";
import ModalModule from "@/store/modules/modal";
import { getPSSWithUUID } from "@/api/gql/product-slot-state";
import Timeout from "await-timeout";
import NotificationService from "@/services/notification.service";
import { generateBookingInvoice, getDownloadBookingTickets, getDownloadTicket, postDownloadBookingTickets, downloadBookingInvoice } from "@/api/booking/booking";
import { getBadgePdf, getGiftcardPdf } from "@/api/gql/badges";
import { base64toPdfBlob } from "@/utils/vue-helpers/badges";
import { InformationType, MEMBERSHIP_TICKETS, PCTypes } from "@/types/db/product-category";
import { getBookingWithUUID } from "@/api/gql/product-slot-boooking";
import { Postcard as badgeIcon, Download as DownloadIcon } from "@element-plus/icons-vue";
import POSConfigModule from "@/store/modules/pos-config";
import { useI18n } from "vue-i18n";
import { isBookingUpdated } from "@/utils/vue-helpers/booking";
import { LogService } from "@/services/logging";
import { isMembershipTicket } from "@/utils/vue-helpers/product-slot-state";
export default defineComponent({
  name: ModalComponents.DownloadTickets,
  setup: function setup() {
    var _selectedBooking$valu, _selectedBooking$valu2;

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var selectedBooking = computed(function () {
      return BookingModule.selectedBooking;
    });
    var modalVisible = dialogVisibleForStatus(ModalStatus.DownloadTickets);
    var ticektsInfo = ref([]);
    var currency = ref((_selectedBooking$valu = selectedBooking.value) === null || _selectedBooking$valu === void 0 ? void 0 : _selectedBooking$valu.currency);
    var pssList = ((_selectedBooking$valu2 = selectedBooking.value) === null || _selectedBooking$valu2 === void 0 ? void 0 : _selectedBooking$valu2.pssList) || [];
    var loading = ref();
    var bookingInfo = ref(null);

    for (var i = 0; i < pssList.length; i++) {
      var _selectedBooking$valu3, _selectedBooking$valu4, _pss$customFieldsAnsw;

      if (pssList[i].bookingStatus !== BookingStatus.Confirmed || pssList[i].pssType === PSSType[PSSType.Retail]) {
        continue;
      }

      var pss = pssList[i];
      var firstName = ((_selectedBooking$valu3 = selectedBooking.value) === null || _selectedBooking$valu3 === void 0 ? void 0 : _selectedBooking$valu3.firstName) || "";
      var lastName = ((_selectedBooking$valu4 = selectedBooking.value) === null || _selectedBooking$valu4 === void 0 ? void 0 : _selectedBooking$valu4.lastName) || "";

      if (pss.customFieldsAnswers && (_pss$customFieldsAnsw = pss.customFieldsAnswers) !== null && _pss$customFieldsAnsw !== void 0 && _pss$customFieldsAnsw.length) {
        for (var j = 0; j < ((_pss$customFieldsAnsw2 = pss.customFieldsAnswers) === null || _pss$customFieldsAnsw2 === void 0 ? void 0 : _pss$customFieldsAnsw2.length); j++) {
          var _pss$customFieldsAnsw2;

          var customFieldType = pss.customFieldsAnswers[j].customField.informationType;

          if (customFieldType === InformationType.FIRSTNAME && pss.customFieldsAnswers[j].answer) {
            firstName = pss.customFieldsAnswers[j].answer;
          }

          if (customFieldType === InformationType.LASTNAME && pss.customFieldsAnswers[j].answer) {
            lastName = pss.customFieldsAnswers[j].answer;
          }
        }
      }

      ticektsInfo.value.push({
        pss: pss,
        firstName: firstName,
        lastName: lastName
      });
    }

    return {
      t: t,
      modalVisible: modalVisible,
      BookingStatus: BookingStatus,
      ticektsInfo: ticektsInfo,
      currency: currency,
      DownloadIcon: DownloadIcon,
      selectedBooking: selectedBooking,
      loading: loading,
      PCTypes: PCTypes,
      badgeIcon: badgeIcon,
      bookingInfo: bookingInfo,
      MEMBERSHIP_TICKETS: MEMBERSHIP_TICKETS,
      isMembershipTicket: isMembershipTicket
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var uid, bookingInfo, retries;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // keep showing the spinner until the booking gets synced
              _this.loading = true;
              uid = BookingModule.selectedBookingUUID;

              if (uid) {
                _context.next = 4;
                break;
              }

              throw new Error("No uuid for this booking");

            case 4:
              retries = 0;

            case 5:
              if (!(!bookingInfo && retries < 5)) {
                _context.next = 15;
                break;
              }

              _context.next = 8;
              return getBookingWithUUID(uid);

            case 8:
              bookingInfo = _context.sent;
              LogService.info("Booking with uuid: ".concat(uid, " was not found when downloading tickets, retrying in 3000ms"));
              retries++;
              _context.next = 13;
              return Timeout.set(3000);

            case 13:
              _context.next = 5;
              break;

            case 15:
              if (bookingInfo) {
                _context.next = 20;
                break;
              }

              // synching failed
              LogService.info("Booking with uuid: ".concat(uid, " was not found when downloading tickets, stopped retrying"));
              NotificationService.showGeneralResponseError();

              _this.closeModal();

              return _context.abrupt("return");

            case 20:
              _this.bookingInfo = bookingInfo;
              _this.loading = false;

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    closeModal: function closeModal() {
      ModalModule.setStatus(ModalStatus.Hidden);
      this.ticektsInfo = [];
    },
    saveFile: function saveFile(url) {
      var uniqueWindowName = "fileDownload_".concat(Date.now());
      window.open(url, uniqueWindowName);
    },
    downloadTicket: function downloadTicket(pss) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var pssInfo, repeat, url;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;

                if (!(pss.id && _this2.selectedBooking.id)) {
                  _context2.next = 5;
                  break;
                }

                pssInfo = {
                  Id: pss.id,
                  BookingId: _this2.selectedBooking.id
                };
                _context2.next = 20;
                break;

              case 5:
                // Repeat request 3 times
                repeat = 0;

              case 6:
                if (!(repeat++ < 3)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 9;
                return getPSSWithUUID(String(pss.uuid));

              case 9:
                pssInfo = _context2.sent;

                if (!(pssInfo != null)) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("break", 16);

              case 12:
                _context2.next = 14;
                return Timeout.set(3000);

              case 14:
                _context2.next = 6;
                break;

              case 16:
                if (!(!pssInfo || !pssInfo.BookingId || !pssInfo.Id)) {
                  _context2.next = 20;
                  break;
                }

                NotificationService.showGeneralResponseError();
                _this2.loading = false;
                throw new Error("Booking with ".concat(_this2.selectedBooking.uuid, " not synced"));

              case 20:
                _context2.next = 22;
                return getDownloadTicket(Number(pssInfo.Id), pssInfo.BookingId);

              case 22:
                url = _context2.sent;

                if (url) {
                  _context2.next = 27;
                  break;
                }

                _this2.loading = false;
                NotificationService.showCustomError(_this2.t("badge.unknown-error"));
                throw new Error("Error downloading the ticket");

              case 27:
                _this2.saveFile(url);

                _this2.loading = false;

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    downloadAllTickets: function downloadAllTickets() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var url;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return postDownloadBookingTickets(_this3.bookingInfo.id);

              case 3:
                _context3.next = 5;
                return getDownloadBookingTickets(_this3.bookingInfo.id);

              case 5:
                url = _context3.sent;

                if (url) {
                  _context3.next = 10;
                  break;
                }

                _this3.loading = false;
                NotificationService.showCustomError(_this3.t("badge.unknown-error"));
                throw new Error("Error downloading the tickets");

              case 10:
                _this3.saveFile(url);

                _this3.loading = false;

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    downloadBadge: function downloadBadge(pss) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var pssListBalances, pssBalance, i, isLocarno, base64pdf, blob, url, errorMessage;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.loading = true; // Check this pss is fully paid or not and show a warning if it's not

                pssListBalances = BookingModule.pssListBalances;
                pssBalance = null;
                i = 0;

              case 4:
                if (!(i < pssListBalances.length)) {
                  _context4.next = 11;
                  break;
                }

                if (!(pssListBalances[i].pssUuid === pss.uuid)) {
                  _context4.next = 8;
                  break;
                }

                pssBalance = pssListBalances[i];
                return _context4.abrupt("break", 11);

              case 8:
                i++;
                _context4.next = 4;
                break;

              case 11:
                if (pssBalance && pssBalance.balance < 0) {
                  NotificationService.showCustomMessage(_this4.t("badge.not-fully-paid"), "warning");
                } // For Locarno we have a special Badge layout


                isLocarno = POSConfigModule.groupId && [19017
                /*Locarno*/
                ].includes(POSConfigModule.groupId) || false;
                _context4.prev = 13;
                _context4.next = 16;
                return getBadgePdf({
                  pssId: pss.id,
                  pssUuid: pss.uuid,
                  isLocarno: isLocarno
                });

              case 16:
                base64pdf = _context4.sent;
                // download the generated pdf file
                blob = base64toPdfBlob(base64pdf);
                url = URL.createObjectURL(blob);

                _this4.saveFile(url);

                NotificationService.showCustomSuccess(_this4.t("completeorder.download-badge-success"));
                _this4.loading = false;
                _context4.next = 46;
                break;

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4["catch"](13);
                errorMessage = "";
                _context4.t1 = _context4.t0.message;
                _context4.next = _context4.t1 === "Ticket Id or Uuid must be provided." ? 30 : _context4.t1 === "Ticket not found!" ? 32 : _context4.t1 === "The requested ticket is not a membership" ? 34 : _context4.t1 === "Image linked to this membership not found" ? 36 : _context4.t1 === "This membership is cancelled." ? 38 : _context4.t1 === "Customer picture linked to this membership is not valid or not found" ? 40 : 42;
                break;

              case 30:
                errorMessage = _this4.t("badge.invalid-ticket");
                return _context4.abrupt("break", 44);

              case 32:
                errorMessage = _this4.t("badge.ticket-not-found");
                return _context4.abrupt("break", 44);

              case 34:
                errorMessage = _this4.t("badge.not-membership ");
                return _context4.abrupt("break", 44);

              case 36:
                errorMessage = _this4.t("badge.image-not-found");
                return _context4.abrupt("break", 44);

              case 38:
                errorMessage = _this4.t("badge.cancelled");
                return _context4.abrupt("break", 44);

              case 40:
                errorMessage = _this4.t("badge.picture-missing");
                return _context4.abrupt("break", 44);

              case 42:
                errorMessage = _this4.t("badge.unknown-error");
                return _context4.abrupt("break", 44);

              case 44:
                NotificationService.showCustomError(errorMessage);
                _this4.loading = false;

              case 46:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[13, 24]]);
      }))();
    },
    downloadGiftcard: function downloadGiftcard(pss) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var base64pdf, blob, url, errorMessage;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.loading = true;
                _context5.prev = 1;
                _context5.next = 4;
                return getGiftcardPdf({
                  pssId: pss.id,
                  pssUuid: pss.uuid
                });

              case 4:
                base64pdf = _context5.sent;
                // download the generated pdf file
                blob = base64toPdfBlob(base64pdf);
                url = URL.createObjectURL(blob);

                _this5.saveFile(url);

                NotificationService.showCustomSuccess(_this5.t("completeorder.download-badge-success"));
                _this5.loading = false;
                _context5.next = 28;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](1);
                errorMessage = "";
                _context5.t1 = _context5.t0.message;
                _context5.next = _context5.t1 === "Ticket Id or Uuid must be provided." ? 18 : _context5.t1 === "Ticket not found!" ? 20 : _context5.t1 === "This giftcard is cancelled." ? 22 : 24;
                break;

              case 18:
                errorMessage = _this5.t("badge.invalid-ticket");
                return _context5.abrupt("break", 26);

              case 20:
                errorMessage = _this5.t("badge.ticket-not-found");
                return _context5.abrupt("break", 26);

              case 22:
                errorMessage = _this5.t("badge.cancelled");
                return _context5.abrupt("break", 26);

              case 24:
                errorMessage = _this5.t("badge.unknown-error");
                return _context5.abrupt("break", 26);

              case 26:
                NotificationService.showCustomError(errorMessage);
                _this5.loading = false;

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 12]]);
      }))();
    },
    downloadInvoice: function downloadInvoice() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this6$bookingInfo;

        var uid, _this6$bookingInfo2, url;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                uid = BookingModule.selectedBookingUUID;

                if (uid) {
                  _context6.next = 3;
                  break;
                }

                throw new Error("No uuid for this booking");

              case 3:
                _this6.loading = true; // if the booking does not have an invoice yet, or it has been updated
                // we need to generate a new invoice

                if (!(!((_this6$bookingInfo = _this6.bookingInfo) !== null && _this6$bookingInfo !== void 0 && _this6$bookingInfo.invoiceId) || BookingModule.isEditOrderBooking && isBookingUpdated())) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 7;
                return generateBookingInvoice(Number((_this6$bookingInfo2 = _this6.bookingInfo) === null || _this6$bookingInfo2 === void 0 ? void 0 : _this6$bookingInfo2.id));

              case 7:
                _context6.next = 9;
                return downloadBookingInvoice(_this6.bookingInfo.id);

              case 9:
                url = _context6.sent;

                if (url) {
                  _context6.next = 15;
                  break;
                }

                _this6.loading = false;
                LogService.info("Error when downloading the invoice, booking: ".concat(uid));
                NotificationService.showGeneralResponseError();
                throw new Error("Error downloading the invoice");

              case 15:
                _this6.saveFile(url);

                _this6.loading = false;

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
});